import React from 'react';
import { useLocation } from 'react-router';

import { AuthenticationMethodProvider } from 'src/shared/providers';
import { isServer } from 'src/shared/utils/environment';
import { baseUrlToLoginSuccessUrl } from 'src/shared/utils/url';

import { LoginComponent, getActiveMethod } from './Component';

export const Login = () => {
  const { pathname } = useLocation();
  const activeMethod = getActiveMethod(pathname);

  const ssoRedirectPath = isServer()
    ? ''
    : baseUrlToLoginSuccessUrl(window.location.href);

  return (
    <AuthenticationMethodProvider
      activeMethod={activeMethod}
      redirectPath={ssoRedirectPath}
    >
      <LoginComponent />
    </AuthenticationMethodProvider>
  );
};
